import React from 'react';

const PageTitle = ({ content }) => (
  <h1 style={{ fontWeight: 300, fontSize: 36, paddingBottom: 20 }}>
    {content}
  </h1>
);

export default PageTitle;
